import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {BuilderTourEnum, NewBuilderTourEnum} from "../../../../../../builder-tour.enum";
import {BuilderHistoryService} from "../../../../../../builder-history.service";
import {BuilderSectionsInteractionService} from "../../../../../../builder-sections-interaction.service";
import {CanvasTourService} from "../../../../../../services/canvas-tour.service";
import {TriggersService} from "../../../../../../services/triggers.service";
import {TextUtils} from "../../../../../../../shared/utils/text-utils";

@Component({
    selector: 'db-page-title',
    templateUrl: './page-title.component.html',
    styleUrl: './page-title.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PageTitleComponent {
  @Input() loading: boolean;
  @Input() generating: boolean;
  @Input() isMobile: boolean;
  @Input() sectionsLimit: number;
  @Output() openSectionTemplates: EventEmitter<void> = new EventEmitter<void>();
  page = {
    title: TextUtils.getText('text_home_page'),
  };

  disabledLoadingSteps = [BuilderTourEnum.OUTLINE_POPUP];
  addTemplateSteps = [BuilderTourEnum.END];
  loadingEnded = false;
  newTourEnum = NewBuilderTourEnum;

  constructor(public builderHistoryService: BuilderHistoryService,
              public canvasTourService: CanvasTourService,
              public triggerService: TriggersService,
              public sectionsInteractionsService: BuilderSectionsInteractionService) {
  }

  openTemplates() {
    if (!this.sectionsInteractionsService.canAddSection.value || this.generating) {
      return;
    }
    setTimeout(() => {
      this.openSectionTemplates.emit();
    });
  }

  closeTour() {
    this.canvasTourService.setTour(NewBuilderTourEnum.ADD_SECTION_BTN, true);
  }
}
